import axios from 'axios';
import {Message} from 'element-ui';
import {Storage} from '@/utils/common';
import {resolveClientBase} from '@/config/base-url';

import router from '@/router';
const toLogin = () => {
  Storage.remove('token');
  router.replace('login');
};

const service = axios.create({
  baseURL: resolveClientBase(process.env.VUE_APP_BASE_URL, process.env.NODE_ENV)
});
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = Storage.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (['get', 'delete'].includes(config.method)) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    config.url = '/api' + config.url;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res;
    }
    if ([10020001, '10020001'].includes(res.data.code)) {
      toLogin();
    }
    if ([10030000, '10030000'].includes(res.data.code)) {
      router.push('/401');
    }
    if (res.data.code !== 0) {
      const errMsg = res.data.msg || '服务未找到';
      Message.error(errMsg);
    }
    return res.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default service;
